import { createContext, useState, useMemo, useContext } from 'react';

const initialState = {
  timelineVisible: false,
  setTimelineVisible: () => {},
};
const ArticleDetailContext = createContext(initialState);

function ArticleDetailProvider({ children }) {
  const [timelineVisible, setTimelineVisible] = useState(initialState.timelineVisible);

  const value = useMemo(
    () => ({
      timelineVisible,
      setTimelineVisible,
    }),
    [timelineVisible, setTimelineVisible]
  );
  return <ArticleDetailContext.Provider value={value}>{children}</ArticleDetailContext.Provider>;
}
export default ArticleDetailProvider;

export const useArticleDetailContext = () => useContext(ArticleDetailContext);
